<template>
  <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y>
    <template v-slot:activator="{ props }">
      <v-text-field
        v-bind="props"
        :model-value="display"
        readonly
        variant="outlined"
        density="compact"
        hide-details
        style="max-width: 300px"
        placeholder="Select years"
      >
        <template v-slot:prepend-inner>
          <v-icon size="small" color="#76237E">mdi-calendar</v-icon>
        </template>
      </v-text-field>
    </template>
    <v-card class="year-picker-card" min-width="280">
      <v-card-title class="text-body-1 font-weight-bold pa-3 pb-1">Select Years</v-card-title>
      <v-divider />
      <div class="year-grid pa-3">
        <v-btn
          v-for="year in availableYears"
          :key="year"
          :color="modelValue.includes(year) ? '#76237E' : undefined"
          :variant="modelValue.includes(year) ? 'flat' : 'outlined'"
          :class="{ 'text-white': modelValue.includes(year) }"
          rounded="lg"
          size="default"
          @click="toggle(year)"
        >
          {{ year }}
        </v-btn>
      </div>
      <v-divider />
      <v-card-actions class="justify-space-between pa-3">
        <v-btn variant="text" size="small" color="#666" @click="$emit('clear')">Clear</v-btn>
        <div class="d-flex ga-2">
          <v-btn variant="text" size="small" color="#666" @click="$emit('select-all')">All</v-btn>
          <v-btn variant="flat" size="small" color="#76237E" @click="menu = false">Done</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'YearPicker',
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    availableYears: {
      type: Array,
      required: true,
    },
    display: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue', 'toggle', 'clear', 'select-all'],
  setup(props, { emit }) {
    const menu = ref(false);

    const toggle = (year) => {
      emit('toggle', year);
    };

    return {
      menu,
      toggle,
    };
  },
};
</script>

<style scoped>
.year-picker-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.year-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
</style>
